// extracted by mini-css-extract-plugin
export default {"terms":"content_terms__Jol03","title":"content_title__c1e79","body":"content_body__xDtDZ"};